<template>
  <div id="tryout-form">
    <!-- begin breadcrumb -->
    <ol class="breadcrumb pull-right">
      <li>
        <router-link :to="{path: '/'}">Home</router-link>
      </li>
      <li>
        <router-link :to="{path: '/tryouts'}">Tryout</router-link>
      </li>
      <li class="active">Create</li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">Buat Tryout Baru</h1>
    <!-- end page-header -->
    <div class="row">
      <div class="col-md-12">
        <div class="panel panel-inverse">
          <div class="panel-heading">
            <h4 class="panel-title">Langkah {{ step }} ( {{ stepName[step -1] }} )</h4>
          </div>
          <div class="panel-body">
            <transition name="fade">
              <app-tryoutform v-if="step == 1" v-on:completed="goToNextStep()"></app-tryoutform>
            </transition>
            <transition name="fade">
              <app-subtestlist v-if="step == 2" v-on:completed="goToNextStep()"></app-subtestlist>
            </transition>
            <transition name="fade">
              <app-tryoutreview v-if="step == 3" v-on:completed="goToNextStep()"></app-tryoutreview>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TryoutForm from '@/components/tryout/TryoutForm'
import SubtestForm from '@/components/tryout/SubtestForm'
import SubtestList from '@/components/tryout/SubtestList'
import TryoutReview from '@/components/tryout/Review'
import TryoutSample from '@/components/tryout/models/TryoutSample.js'
import TryoutService from '@/services/tryout.js'

export default
{
  name: 'tryout-wizard',
  components: {
    'app-tryoutform': TryoutForm,
    'app-subtestform': SubtestForm,
    'app-subtestlist': SubtestList,
    'app-tryoutreview': TryoutReview
  },
  data: function() {
    return {
      step: 1,
      stepName: ['Membuat Tryout', 'Membuat Subtest', 'Review Tryout'],
    }
  },
  methods: {
    goToNextStep: function() {
      this.step++
    }
  }
}
</script>



// WEBPACK FOOTER //
// Form.vue?088e2bfe